import { createReducer, on } from '@ngrx/store';
import { initialMonitoringState, MonitoringState } from './monitoring.state';
import * as MonitoringActions from './monitoring.actions';

export const monitoringReducer = createReducer(
  initialMonitoringState,

  // Load Clients
  on(MonitoringActions.loadClients, (state, { filters }) => ({
    ...state,
    loading: true,
    error: null,
    filters,
  })),
  on(MonitoringActions.loadClientsSuccess, (state, { clients }) => ({
    ...state,
    clients,
    loading: false,
  })),
  on(MonitoringActions.loadClientsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Load Status Columns
  on(MonitoringActions.loadStatusColumns, state => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(MonitoringActions.loadStatusColumnsSuccess, (state, { columns }) => ({
    ...state,
    statusColumns: columns,
    loading: false,
  })),
  on(MonitoringActions.loadStatusColumnsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Update Client Status
  on(MonitoringActions.updateClientStatus, state => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(MonitoringActions.updateClientStatusSuccess, (state, { clientId, status }) => {
    const updatedClients = state.clients.map(client =>
      client.id === clientId ? { ...client, status: status as any } : client
    );
    return {
      ...state,
      clients: updatedClients,
      loading: false,
    };
  }),
  on(MonitoringActions.updateClientStatusFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Clear All
  on(MonitoringActions.clearAll, () => initialMonitoringState)
);
